import { inject, injectable } from 'inversify'
import { SERVICE_TYPES } from '@/core/container/types'
import type TeamWorkflowService from '@/services/domain/accounts/teamWorkflowService'

@injectable()
export class DealsAccessControlService {
  constructor(@inject(SERVICE_TYPES.TeamWorkflowService) protected readonly teamWorkflowService: TeamWorkflowService) {}

  public isAccessAllowed(): boolean {
    return this.teamWorkflowService.isUsersWorkflowNotUserRole()
  }
}
